import { Component, OnInit, Input, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, NgForm } from '@angular/forms';
import { PropertyListingService } from '../../../shared/providers/property-listing.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CommonService } from '../../../shared/providers/common.service';
import { DealTeamInput } from '../../../shared/models/DealTeamInput';
import { ToastService } from '../../../shared/providers/toast.service';
import { Subject } from 'rxjs';
import { EmailValidator } from '../../../shared/providers/validation.service';
import { LoaderService } from '../../../shared/providers/loader.service';
import { AuthenticationService } from '../../../shared/auth/authentication.service';

@Component({
  selector: 'app-deal-contacts',
  templateUrl: './deal-contacts.component.html',
  styleUrls: ['./deal-contacts.component.css']
})
export class DealContactsComponent implements OnInit {
  @Input() propertyId = 0;
  @Input() IsPDeleted: boolean = false;
  dealContacts = [];
  searchText = "";
  modalRef: BsModalRef;
  modalRefDelete: BsModalRef;
  deleteId = 0;
  dealContactForm: FormGroup;
  showCreate = false;
  filterData = [];
  isSubmitted = false;
  userId: number = 0;
  dealContactInputModel: DealTeamInput = {
    ContactType: null, Id: 0, FirstName: null, LastName: null, Email: null, ContactTypeId: null, PropertyId: this.propertyId, Phone: null
  };
  contactTypes = [];
  dtOptions = {};
  dtTrigger: Subject<any> = new Subject();
  IsLoading = false;
  header = "Add";
  @ViewChild('createDealTeam') accept: TemplateRef<null>;
  constructor(private propertyListing: PropertyListingService,
    private modalService: BsModalService, private commonService: CommonService, private _toastService: ToastService, private loader: LoaderService, public authService: AuthenticationService) { }

  ngOnInit() {

    let user: any;
    user = this.authService.user;
    this.userId = user.Id;
    this.IsLoading = true;
    this.dtOptions = {
      processing: true,
      lengthChange: false,
      paging: false,
      search: true,
      ordering: false,
      searching: true,
      info: false,
      language: {
        zeroRecords: null,
        searchPlaceholder: "Search",
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
    };
  
    setTimeout(() => {
      const el = document.getElementById('deal-contact-list_processing');
      if (el) {
        el.style.removeProperty('display');
      }
    }, 100);
this.loadDealContacts();
    //#endregion
    this.dealContactForm = new FormGroup({
      'txtFirstName': new FormControl(this.dealContactInputModel.FirstName, [
        Validators.required
      ]),
      'txtLastName': new FormControl(this.dealContactInputModel.LastName, [
        Validators.required
      ]),
      'txtEmail': new FormControl(this.dealContactInputModel.Email, [
        EmailValidator
      ]),
      'txtPhone': new FormControl(this.dealContactInputModel.Phone, [
        Validators.minLength(10)
      ]),
      'lstRole': new FormControl(this.dealContactInputModel.ContactTypeId, [
        Validators.required
      ])
    });

    //this.getRoles();
  }
  get txtFirstName() { return this.dealContactForm.get('txtFirstName'); }
  get txtLastName() { return this.dealContactForm.get('txtLastName'); }
  get lstRole() { return this.dealContactForm.get('lstRole'); }
  get txtEmail() { return this.dealContactForm.get('txtEmail'); }
  get txtPhone() { return this.dealContactForm.get('txtPhone'); }


  loadDealContacts() {
    this.propertyListing.GetDealContacts(this.propertyId).subscribe(res => {
      this.dealContacts = res;
      this.filterData = res;
      const el = document.getElementById('deal-contact-list_processing');
      if (el) {
        el.style.display = 'none';
      }
    });
  }
  create(isUpdate: boolean) {
    this.header = isUpdate ? "Update" : "Add";
    if (!isUpdate) {
      this.dealContactForm.reset();
      this.dealContactInputModel = {
        ContactType: null, Id: 0, FirstName: null, LastName: null, Email: null, ContactTypeId: null, PropertyId: this.propertyId, Phone: null
      };
    }
    this.openModal(this.accept, 'panlestyle')
  }

  openModal(template: TemplateRef<any>, classes) {
    this.modalRef = this.modalService.show(template, { class: classes });
    this.getContactTypes();
    this.showCreate = true;
  }

  getContactTypes() {
    this.commonService.GetDealContactTypes().subscribe(res => {

      this.contactTypes = res;
      console.log(res);

    });
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    //this.dealContacts.filter = filterValue;
  }
  addDealTeam() {
    this.isSubmitted = true;
    if (!this.dealContactForm.invalid) {
      this.dealContactInputModel.PropertyId = this.propertyId;
      this.propertyListing.addDealTeam(this.dealContactInputModel).subscribe(res => {

        this.isSubmitted = false;
        if (this.dealContactInputModel.Id > 0) {
          this._toastService.addToast({
            title: 'Success',
            msg: `Deal Contact Updated Successfully`,
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'success'
          });
        }
        else {
          this._toastService.addToast({
            title: 'Success',
            msg: `Deal Contact added Successfully`,
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'success'
          });
        }
        this.onClose();
        setTimeout(() => {
          const el = document.getElementById('deal-contact-list_processing');
          if (el) {
            el.style.removeProperty('display');
          }
        }, 100);
        this.loadDealContacts();
      });
    }
    else {
      this.dealContactForm.updateValueAndValidity();
      this.isSubmitted = false;
      this._toastService.addToast({
        title: 'Unable to save changes',
        msg: 'Some fields still have invalid data or some mandatory fields are missing.',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'warning'
      });
      //this.lo.display(false);
      return;
    }
  }

  edit(deal) {

    this.header = "Update";
    this.dealContactInputModel.PropertyId = this.propertyId;
    this.dealContactInputModel.FirstName = deal.FirstName;
    this.dealContactInputModel.LastName = deal.LastName;
    this.dealContactInputModel.Email = deal.Email;
    this.dealContactInputModel.Phone = deal.Phone;
    this.dealContactInputModel.ContactTypeId = deal.ContactTypeId;
    this.dealContactInputModel.Id = deal.Id;
    this.create(true);
  }
  onClose() {
    this.modalRef.hide();
    this.showCreate = false;
    this.dealContactInputModel = {
      ContactType: null, Id: 0, FirstName: null, LastName: null, Email: null, ContactTypeId: null, PropertyId: this.propertyId, Phone: null
    };
  }
  delete() {
    this.propertyListing.deleteDealTeam(this.deleteId, this.propertyId).subscribe(res => {
      this.dealContactInputModel = {
        ContactType: null, Id: 0, FirstName: null, LastName: null, Email: null, ContactTypeId: null, PropertyId: this.propertyId, Phone: null
      };
      this._toastService.addToast({
        title: 'Delete',
        msg: `Deleted Successfully`,
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'success'
      });
      this.modalRefDelete.hide();
      setTimeout(() => {
        const el = document.getElementById('deal-contact-list_processing');
        if (el) {
          el.style.removeProperty('display');
        }
      }, 100);
      this.loadDealContacts();
    });
  }
  search(term: string) {
    if (!term) {
      this.filterData = this.dealContacts;
    } else {
      this.filterData = this.dealContacts.filter(x =>
        x.FirstName.trim().toLowerCase().includes(term.trim().toLowerCase()) ||
        x.LastName.trim().toLowerCase().includes(term.trim().toLowerCase()) ||
        x.Email.trim().toLowerCase().includes(term.trim().toLowerCase())
      );
    }
  }
  openDeleteModal(template: TemplateRef<any>, classes: any, id: number) {
    this.deleteId = id;
    this.modalRefDelete = this.modalService.show(template, { class: classes });
  }
  cancel() {
    this.dealContactForm.reset();
    this.modalRef.hide();
  }
}
